/**
 * @author lifei
 * 功能：缓存处理，涉及到应用的存储需要使用 cache 实例方法，不使用 原生的存储方式。后期考虑注册的方式定义存储
 */
import { Memory } from './memory'

export class Cache extends Memory {
  private constructor() {
    super()
  }

  /**
   * 功能：token
   */
  public static TOKEN = new Memory('TOKEN', 'local')

  /**
   * 功能：登录信息
   */
  public static LOGIN_INFO = new Memory('loginInfo', 'local')

  /**
   * 功能：获取 oss 认证信息
   */
  public static OSS = new Memory('OSS', 'local')

  /**
   * 功能：页签导航
   */
  public static TABS = new Memory('tabs', 'local')

  /**
   * 功能：当前活跃的 tab
   */
  public static ACTIVE_TAB = new Memory('activeTab', 'local')

  /**
   * 功能：收藏
   */
  public static FAVORITES = new Memory('favorites', 'local')

  /**
   * 功能：主题
   */
  public static THEME = new Memory('theme', 'local')

  /**
   * 功能：当前业务组 id
   */
  public static BUS_ID = new Memory('busId', 'local')

  /**
   * 功能：需要缓存的页面
   */
  public static KEEP_ALIVE_KEYS = new Memory('keepAliveKeys', 'local')
}
